import DraftJS from 'draft-js'
import { Attachment, BaseModel, Edition, MachineLearningModel, User } from '../api-v2'
import { ArpAccess } from '../arpMedia'

export const DEFAULT_TIER = 'Kit'

export interface MediaCollectionMetadata {}

export enum MediaCollectionDemoType {
  AUDIO = 'audio',
  VIDEO = 'video'
}

export enum MediaCollectionType {
  PACK = 'pack',
  SONG_REMIX = 'song_remix',
  VOICE_MODEL = 'voice_model'
}

export interface MediaCollectionTier {
  name: string
  mediaIds: number[]
  description?: string
  tag?: string
  hexColor?: string
  coverImageUrl?: string // the location in the s3 (public) bucket where the cover image for this tier is stored
  zipName?: string // the location in the s3private bucket where the zip file for this tier is stored
}

export interface MediaCollection extends BaseModel {
  royaltyPercentage: number | null
  collectionType: MediaCollectionType
  isPublished: boolean
  discussionId: number
  title: string
  slug: string
  description: DraftJS.RawDraftContentState
  tags: string[]
  coverImage: Attachment
  coverImageArweaveUrl?: string
  blurhash: string
  demoData: Attachment
  demoDataArweaveUrl?: string
  demoType: MediaCollectionDemoType
  editionId?: number
  edition?: Edition
  access?: ArpAccess
  userId?: number
  user: User
  tiers?: Record<string, MediaCollectionTier>
  mediaCount: number
  requiresTrackPublishApproval: boolean
  machineLearningModel: MachineLearningModel | null
  hasAcceptedTermsAndConditions: boolean
}
